import { memo, useState } from "react";
import Button from "@mui/material/Button";
import Iconify from "lib/iconify";
import Resource from "ui/layouts/Resource";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import AddKycDialog from "ui/organizms/PspKycSettings/AddKycDialog";
import PspKycSettingsTable from "ui/organizms/PspKycSettings/PspKycSettingsTable";

const PSPKYCSettings = (props: ScreenProps) => {
    const [isAddOpen, setIsAddOpen] = useState(false);

    const openAdd = () => setIsAddOpen(true);
    const closeAdd = () => setIsAddOpen(false);

    const addButton = (
        <Button
            variant='contained'
            startIcon={<Iconify icon='mdi:plus' />}
            onClick={openAdd}
            data-test-id='pspKycSettings.add'
        >
            Add New KYC
        </Button>
    );

    return (
        <Screen
            {...props}
            title='KYC Settings | PSP KYC Settings'
        >
            <Resource
                breadcrumbsProps={{
                    heading: 'PSP KYC Settings',
                    links: []
                }}
            >
                <PspKycSettingsTable action={addButton} />
            </Resource>
            <AddKycDialog open={isAddOpen} onClose={closeAdd} />
        </Screen>
    );
};

export default memo(PSPKYCSettings);
